<section class="billing__data">
    <div class="billing__data__content px-md-4 px-2 pb-4">
        <div class="billing__data__content__container mt-2">
            <div
                class="billing__data__content__container__choose px-md-4 px-2 d-flex flex-column"
            >
                <span
                    class="billing__data__content__container__choose__title mb-1 mt-4"
                >
                    {{
                        'fe_precheckin_billing_data_content_container_choose_title'
                            | translate
                    }}
                </span>
                <span
                    class="billing__data__content__container__choose__subtitle mb-2"
                >
                    {{
                        'fe_precheckin_billing_data_content_container_choose_subtitle_first'
                            | translate
                    }}
                    <a href="https://cfdi.alamo.com.mx/"
                        >https://cfdi.alamo.com.mx/</a
                    >
                </span>
                <div
                    class="billing__data__content__container__choose__radio d-flex flex-column flex-sm-row justify-content-left align-items-start px-md-1 px-2 mb-3"
                >
                    <div class="d-flex flex-row">
                        <input
                            class="mb-sm-0 mb-3"
                            type="radio"
                            name="noBilling"
                            id="no"
                            value="no"
                            [(ngModel)]="billingOption"
                        />
                        <label for="no" class="px-3">{{
                            'fe_precheckin_billing_data_content_container_choose_radio_no'
                                | translate
                        }}</label>
                    </div>
                    <div class="d-flex flex-row">
                        <input
                            class="ps-2"
                            type="radio"
                            name="yesBilling"
                            id="yes"
                            value="yes"
                            [(ngModel)]="billingOption"
                        />
                        <label for="yes" class="px-3">{{
                            'fe_precheckin_billing_data_content_container_choose_radio_yes'
                                | translate
                        }}</label>
                    </div>
                </div>

                <div
                    *ngIf="billingOption === 'yes'"
                    class="billing__data__content__container__choose__billing mt-2"
                >
                    <form [formGroup]="billingForm" (ngSubmit)="onSubmit()">
                        <div class="col-12 col-md-6">
                            <fe-input
                                class="mb-3 mt-2"
                                [id]="'rfc'"
                                [label]="
                                    'fe_precheckin_billing_data_content_container_choose_billing_rfc'
                                        | translate
                                "
                                [tabIndex]="'1001'"
                                [uppercase]="true"
                                [maxlength]="'13'"
                                formControlName="rfc"
                            ></fe-input>
                        </div>
                        <div class="col-12 col-md-6">
                            <fe-input
                                class="mb-3 mt-2"
                                [id]="'businessName'"
                                [label]="
                                    'fe_precheckin_billing_data_content_container_choose_billing_business'
                                        | translate
                                "
                                [tabIndex]="'1002'"
                                formControlName="businessName"
                            ></fe-input>
                        </div>
                        <div class="col-12 col-md-6">
                            <fe-input
                                class="mb-3 mt-2"
                                [id]="'email'"
                                [label]="
                                    'fe_precheckin_billing_data_content_container_choose_billing_email'
                                        | translate
                                "
                                [tabIndex]="'1003'"
                                formControlName="email"
                            ></fe-input>
                        </div>
                    </form>
                    <div
                        class="billing__data__content__container__choose__billing__address mb-1 mt-4 d-flex flex-column"
                    >
                        <span
                            class="billing__data__content__container__choose__billing__address__title mb-4"
                        >
                            {{
                                'fe_precheckin_billing_data_content_container_choose_billing_address_title'
                                    | translate
                            }}
                        </span>
                        <span
                            class="billing__data__content__container__choose__billing__address__title__two my-2"
                        >
                            {{
                                'fe_precheckin_billing_data_content_container_choose_billing_address_title_two'
                                    | translate
                            }}
                        </span>
                        <div
                            class="billing__data__content__container__choose__billing__address__radio d-flex flex-column flex-sm-row justify-content-left align-items-start px-md-1 px-2 mb-3"
                        >
                            <div class="d-flex flex-row">
                                <input
                                    class="mb-sm-0 mb-3"
                                    type="radio"
                                    name="sameAddress"
                                    id="sameAddress"
                                    value="sameAddress"
                                    [(ngModel)]="addressOption"
                                />
                                <label for="sameAddress" class="px-3">
                                    {{
                                        'fe_precheckin_billing_data_content_container_choose_billing_address_radio_same'
                                            | translate
                                    }}
                                </label>
                            </div>
                            <div class="d-flex flex-row">
                                <input
                                    class="ps-2"
                                    type="radio"
                                    name="differentAddress"
                                    id="differentAddress"
                                    value="differentAddress"
                                    [(ngModel)]="addressOption"
                                />
                                <label for="differentAddress" class="px-3"
                                    >{{
                                        'fe_precheckin_billing_data_content_container_choose_billing_address_radio_different'
                                            | translate
                                    }}
                                </label>
                            </div>
                        </div>
                        <div
                            *ngIf="addressOption === 'differentAddress'"
                            class="billing__data__content__container__choose__billing mt-2"
                        >
                            <form
                                [formGroup]="addressForm"
                                (ngSubmit)="onSubmit()"
                                class="d-flex flex-wrap"
                            >
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'street'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_street'
                                                | translate
                                        "
                                        [tabIndex]="'1004'"
                                        formControlName="street"
                                    ></fe-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'number'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_number'
                                                | translate
                                        "
                                        [tabIndex]="'1005'"
                                        formControlName="number"
                                    ></fe-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        *ngIf="
                                            addressService.states.length === 0
                                        "
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'state'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_state'
                                                | translate
                                        "
                                        [tabIndex]="'1006'"
                                        [loading]="loadingStates"
                                        formControlName="state"
                                    ></fe-input>
                                    <fe-input
                                        *ngIf="addressService.states.length > 0"
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'state'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_state'
                                                | translate
                                        "
                                        [tabIndex]="'1006'"
                                        [isSelect]="true"
                                        [items]="addressService.states"
                                        [selectType]="'typing'"
                                        [loading]="loadingStates"
                                        (change)="onChangeState()"
                                        formControlName="state"
                                    ></fe-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        *ngIf="
                                            addressService.cities.length === 0
                                        "
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'city'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_city'
                                                | translate
                                        "
                                        [tabIndex]="'1007'"
                                        [loading]="loadingCities"
                                        formControlName="city"
                                    ></fe-input>
                                    <fe-input
                                        *ngIf="addressService.cities.length > 0"
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'city'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_city'
                                                | translate
                                        "
                                        [tabIndex]="'1007'"
                                        [isSelect]="true"
                                        [items]="addressService.cities"
                                        [selectType]="'typing'"
                                        [loading]="loadingCities"
                                        (change)="onChangeCity()"
                                        formControlName="city"
                                    ></fe-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        *ngIf="
                                            addressService.neighborhoods
                                                .length === 0
                                        "
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'neighborhood'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_neighborhood'
                                                | translate
                                        "
                                        [tabIndex]="'1008'"
                                        [loading]="loadingNeighborhoods"
                                        formControlName="neighborhood"
                                    ></fe-input>
                                    <fe-input
                                        *ngIf="
                                            addressService.neighborhoods
                                                .length > 0
                                        "
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'neighborhood'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_neighborhood'
                                                | translate
                                        "
                                        [tabIndex]="'1008'"
                                        [isSelect]="true"
                                        [items]="addressService.neighborhoods"
                                        [selectType]="'typing'"
                                        [loading]="loadingNeighborhoods"
                                        (change)="onChangeNeighborhood()"
                                        formControlName="neighborhood"
                                    ></fe-input>
                                </div>
                                <div class="col-12 col-md-6">
                                    <fe-input
                                        class="mb-3 mt-2 pe-md-4 pe-0"
                                        [id]="'postalCode'"
                                        [label]="
                                            'fe_precheckin_billing_data_content_container_choose_billing_postal'
                                                | translate
                                        "
                                        [tabIndex]="'1009'"
                                        [disabled]="disabledZipCode"
                                        [mask]="'00000'"
                                        formControlName="postalCode"
                                    ></fe-input>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="billing__data__content__container__image">
                <img
                    [src]="'images/QR2.JPG' | cdn"
                    alt="logo alamo"
                    class="billing__data__content__container__image mt-4"
                    width="250"
                />
            </div>
        </div>
    </div>
</section>
